import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IXmlDealer } from '../models/models'

export class AddUpdateXmlApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dealerXml/addUpdateXml',
      requesterInfo,
    })
  }

  public async addUpdateXml(request: IXmlDealer): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
